import { AppAvatar } from "@lib/components/AppComponents";
import { booleanColor } from "@lib/helpers/ColorHelper";
import { useTypedSelector } from "@lib/redux";
import { AuthRoles } from "@lib/types";
import { Customer } from "@lib/types/Customer";
import { AvatarSize } from "@lib/types/General";

type Props = {
  customer: Customer;
  maxWidth?: number;
  maxHeight?: number;
  fallback?: JSX.Element;
  preview?: boolean;
  size?: AvatarSize;
};
export default function CustomerLogo(props: Props) {
  const { customer, fallback, size = "medium" } = props;
  const { role } = useTypedSelector((state) => state.auth?.user);
  const logo = customer?.logoUrl || "";

  if (role === AuthRoles.ProviderAgent) {
    return null;
  }

  if (!logo && fallback) {
    return fallback;
  }

  return (
    <AppAvatar
      src={logo}
      border={{ color: booleanColor(customer?.enabled) }}
      objectFit="contain"
      size={size as any}
      className="customer-logo-avatar"
    />
  );

  // return (
  //   <Image
  //     src={logo}
  //     style={{
  //       width: "150px",
  //       maxWidth: maxWidth ? `${maxWidth}px` : "150px",
  //       maxHeight: maxHeight ? `${maxHeight}px` : "100px",
  //       objectFit: "contain",
  //     }}
  //     preview={preview}
  //   />
  // );
}
